
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M8.25 6.59V8.5l.91.955m1.828 2.45-.212 2.437a1.3 1.3 0 0 1-.392.827 1.18 1.18 0 0 1-.823.331H6.933a1.18 1.18 0 0 1-.823-.331 1.3 1.3 0 0 1-.392-.827l-.212-2.437m.006-6.81.212-2.437c.028-.316.167-.61.39-.824.224-.215.516-.334.819-.334h2.64c.305-.001.598.117.823.331s.364.51.392.827L11 5.095M12.5 8.5c0 2.46-1.903 4.454-4.25 4.454S4 10.96 4 8.5s1.903-4.455 4.25-4.455S12.5 6.04 12.5 8.5"}})])
          )
        }
      }
    